import React, { Component } from "react";
import { getSummaryImageSvg } from "../actions/enquiry";
import { connect } from "react-redux";
import Loading from "./Loading";

class SummaryImage extends Component {
    componentDidMount() {
        let { Product, getSummaryImageSvg } = this.props;
        if (!Product.SvgImage) {
            let svgData;

            // build different data object depending on the product type
            if (Product.ItemType.Name === "Window") {
                svgData = {
                    styleId: Product.Design.Id,
                    productId: Product.Style.Id,
                    width: Product.Size.Width,
                    height: Product.Size.Height,
                    colourId: Product.Colour.Id,
                    roomId: Product.Room.Id,
                    extraIdList: [Product.Handle.Id]
                };
                if (Product.HasLock) svgData.extraIdList.push(Product.Lock.Id);
            } else if (Product.ItemType.Name === "Door") {
                svgData = {
                    productId: Product.Type.Id,
                    styleId: Product.Model.Id,
                    width: Product.Size.Width,
                    height: Product.Size.Height,
                    colourId: Product.Colour.Id,
                    roomId: Product.Room.Id,
                    extraIdList: [Product.Handle.Id]
                };
                if (Product.HasLock) svgData.extraIdList.push(Product.Lock.Id);
                if (Product.HasLetterbox) svgData.extraIdList.push(Product.Letterbox.Id);

            }else if(Product.ItemType.Name === "Conservatory"){
                svgData = {
                    productId: Product.Room.Id,
                    styleId: Product.Style.Id,
                    width: Product.Size.Width,
                    height: Product.Size.Height,
                    colourId: Product.Colour.Id,
                    roomId: 25,
                };
            }

            // call the svg and add it to the state
            getSummaryImageSvg(svgData, Product.randomIdForImageReplacement);
        }
    }

    render() {
        let { Product } = this.props;

        if (!Product.SvgImage) return <Loading text={false} />;

        let svg = Product.SvgImage.replace("width=\"100%\"", "").replace("height=\"100%\"", "");

        // calculate the ratio because SVG don't like automatic resizing?
        var maxWidth = Product.Size.Width / Product.Size.Height * 300;

        // max width on a LARGE screen
        maxWidth = Math.min(maxWidth, 240);

        return <img className="SummaryImage" style={{ maxHeight: 300, maxWidth: maxWidth, width: 'auto', height: 'auto' }} src={"data:image/svg+xml;base64," + window.btoa(svg)} alt="" />;
    }
}

export default connect(null, { getSummaryImageSvg })(SummaryImage);



// WEBPACK FOOTER //
// ./src/components/SummaryImage.js